(function () {

  const popup =
    document.getElementById('WomenCheckoutPopup');

  const checkbox =
    document.getElementById('WomenCheckoutAccept');

  const continueBtn =
    document.getElementById('WomenCheckoutContinue');

  if (!popup || !checkbox || !continueBtn) {
    console.error('WOMEN CHECKOUT POPUP: required elements not found');
    return;
  }


  const closeBtn =
    popup.querySelector('.women-checkout-popup__close');

  const cancelBtn =
    popup.querySelector('.women-checkout-popup__cancel');

  const overlay =
    popup.querySelector('.women-checkout-popup__overlay');


  function openPopup() {

    checkbox.checked = false;
    continueBtn.disabled = true;

    popup.classList.add('is-open');
    popup.setAttribute('aria-hidden', 'false');

    document.body.classList.add(
      'women-checkout-popup-open'
    );

  }


  function closePopup() {

    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');

    document.body.classList.remove(
      'women-checkout-popup-open'
    );

  }


  checkbox.addEventListener(
    'change',
    function () {

      continueBtn.disabled = !this.checked;

    }
  );


  /*
    Checkout Button
  */

  document.addEventListener(
    'click',
    function (event) {

      const checkoutBtn =
        event.target.closest(
          '#CartDrawer-Checkout'
        );

      if (!checkoutBtn) return;


      event.preventDefault();

      event.stopPropagation();

      event.stopImmediatePropagation();


      openPopup();

    },
    true
  );


  /*
    Continue to Shopify Checkout
  */

  continueBtn.addEventListener(
    'click',
    function () {

      if (!checkbox.checked) return;

      window.location.href = '/checkout';

    }
  );


  /*
    Close Popup
  */

  if (closeBtn) {
    closeBtn.addEventListener(
      'click',
      closePopup
    );
  }


  if (cancelBtn) {
    cancelBtn.addEventListener(
      'click',
      closePopup
    );
  }


  if (overlay) {
    overlay.addEventListener(
      'click',
      closePopup
    );
  }


  document.addEventListener(
    'keydown',
    function (event) {

      if (
        event.key === 'Escape' &&
        popup.classList.contains('is-open')
      ) {

        closePopup();

      }

    }
  );


  console.log(
    'WOMEN CHECKOUT POPUP READY'
  );

})();